<template>
    <a-button :disabled="disabled" :class="className" :type="type" :loading="loading" :shape="shape" @click="clickHandle" :size="size">
        <template v-if="lable">
            {{lable}}
        </template>
        <slot v-else name="lable"></slot>
    </a-button>
</template>

<script>

    export default {
        props:["lable","type","className","disabled","shape","size"],
        name:"button-load",
        data() {
            return {
                loading:false
            };
        },
        computed: {},
        methods: {
            clickHandle(){
                this.loading = true;
                this.$emit("clickHandle",this);
            },
            closeLoad(){
                this.loading = false;
            }
        },
        created() {},
        mounted() {},
        watch: {}
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ui/button-load.vue